import { render, staticRenderFns } from "./SetPush.vue?vue&type=template&id=f71e48e2"
import script from "./SetPush.vue?vue&type=script&lang=js"
export * from "./SetPush.vue?vue&type=script&lang=js"
import style0 from "./SetPush.vue?vue&type=style&index=0&id=f71e48e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports